// Lists the types of inputs used to enter results for grades.
export default {
  TEXT: 'TEXT',
  RADIO: 'RADIO',
  SELECT: 'SELECT',
};
